import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { DepositActionRuleDTO } from './deposit-ticker-action.model';

@Injectable({
  providedIn: 'root',
})
export class DepositTickerRuleService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<DepositActionRuleDTO[]> {
    return this.http.get<DepositActionRuleDTO[]>('/deposit-action-rules');
  }

  update(dto: DepositActionRuleDTO): Observable<DepositActionRuleDTO> {
    return this.http.put<DepositActionRuleDTO>(`/deposit-action-rules/${dto.id}`, dto);
  }

  insert(dto: DepositActionRuleDTO): Observable<DepositActionRuleDTO> {
    return this.http.post<DepositActionRuleDTO>('/deposit-action-rules', dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`/deposit-action-rules/${id}`);
  }
}
